import { createFileRoute, Link } from "@tanstack/react-router";

import { ServicePageLayout } from "../components/site/ServicePageLayout";
import { Reveal } from "../components/site/Reveal";
import { posts } from "../content/blog";
import { routes, serviceGroups } from "../lib/nav";
import { SITE_URL, buildMeta } from "../lib/site";

const title = "Карта сайта — hay.agency";
const description =
  "Все страницы hay.agency: услуги, проекты, блог, контакты и документы.";

export const Route = createFileRoute("/sitemap")({
  head: () => buildMeta({
    title,
    description,
    path: "/sitemap",
    image: `${SITE_URL}/og/default.webp`,
    imageWidth: 1200,
    imageHeight: 630,
    imageAlt: "hay.agency",
    locale: "ru_RU",
  }),
  component: SitemapPage,
});

const companyLinks = [
  { label: "Главная", to: routes.home },
  { label: "Мы", to: routes.about },
  { label: "Проекты", to: routes.cases },
  { label: "Блог", to: routes.blog },
  { label: "Контакты", to: routes.contacts },
  { label: "Вакансии", to: routes.vacancies },
  { label: "Политика конфиденциальности", to: routes.privacy },
];

const blogLinks = [...posts]
  .sort((a, b) => (b.datePublished ?? "").localeCompare(a.datePublished ?? ""))
  .map((p) => ({ label: p.title, to: `${routes.blog}/${p.slug}` }));

function Column({
  title: heading,
  links,
}: {
  title: string;
  links: { label: string; to: string }[];
}) {
  return (
    <div>
      <div className="mb-[16px] text-[24px] font-medium leading-[26px] tracking-[-0.7px] lg:text-[30px] lg:leading-[30px] lg:tracking-[-0.9px]">
        {heading}
      </div>
      <ul>
        {links.map((link) => (
          <li key={link.label} className="mb-[14px] last:mb-0">
            <Link
              to={link.to}
              className="inline-block text-[14px] font-normal leading-[17px] tracking-[-0.2px] text-muted-foreground transition-colors duration-300 hover:text-brand-text"
            >
              {link.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}

function SitemapPage() {
  return (
    <ServicePageLayout breadcrumb="Карта сайта">
      <section className="px-5 pt-10 lg:px-[21px] lg:pt-[62px]">
        <Reveal priority>
          <h1 className="section-title">Карта сайта</h1>
        </Reveal>

        <div className="mt-10 grid gap-10 pb-16 sm:grid-cols-2 lg:mt-[62px] lg:grid-cols-4 lg:gap-[42px] lg:pb-[110px]">
          {serviceGroups.map((group) => (
            <Column
              key={group.title}
              title={group.title}
              links={group.links.flatMap((l) => [l, ...(l.children ?? [])])}
            />
          ))}
          <Column title="Компания" links={companyLinks} />
        </div>

        <Reveal>
          <h2 className="text-[30px] font-medium leading-[32px] tracking-[-0.9px] lg:text-[40px] lg:leading-[42px]">
            Статьи блога
          </h2>
        </Reveal>
        <div className="mt-8 grid gap-x-[42px] gap-y-[14px] pb-20 sm:grid-cols-2 lg:mt-[40px] lg:grid-cols-3 lg:pb-[110px]">
          {blogLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className="text-[14px] font-normal leading-[18px] tracking-[-0.2px] text-muted-foreground transition-colors duration-300 hover:text-brand-text"
            >
              {link.label}
            </Link>
          ))}
        </div>
      </section>
    </ServicePageLayout>
  );
}
